import React from 'react';
import { Box, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { GrouperView } from '../../../../../../services/ContractService/types/contractTypes';
import { useGrouperForm } from './hooks';
import { GrouperFormFields, DialogActionButtons } from './components';

interface AddEditGrouperDialogProps {
    open: boolean;
    editingGrouper: GrouperView | null;
    onClose: () => void;
}

const AddEditGrouperDialog: React.FC<AddEditGrouperDialogProps> = ({
    open,
    editingGrouper,
    onClose
}) => {
    const {
        formData,
        formErrors,
        handleFormChange,
        handleSave,
        handleDelete
    } = useGrouperForm({
        editingGrouper,
        open,
        onClose
    });

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                {editingGrouper ? 'Edit Grouper' : 'Add New Grouper'}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                    <GrouperFormFields
                        code={formData.code}
                        rate={formData.rate}
                        isPerDiem={formData.isPerDiem}
                        codeError={formErrors.code}
                        rateError={formErrors.rate}
                        onCodeChange={(value) => handleFormChange('code', value)}
                        onRateChange={(value) => handleFormChange('rate', value)}
                        onIsPerDiemChange={(value) => handleFormChange('isPerDiem', value)}
                    />
                </Box>
            </DialogContent>

            <DialogActionButtons
                isEditing={!!editingGrouper}
                onCancel={onClose}
                onDelete={handleDelete}
                onSave={handleSave}
            />
        </Dialog>
    );
};

export default AddEditGrouperDialog;
